import { render, staticRenderFns } from "./FInfoHighlight.vue?vue&type=template&id=d9931b34&"
import script from "./FInfoHighlight.vue?vue&type=script&lang=ts&"
export * from "./FInfoHighlight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports